import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=c838054c"
import script from "./WhatsNew.vue?vue&type=script&lang=js"
export * from "./WhatsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports